import { useMemo } from 'react'

import {
  AssigneesProjectResponseType,
  WorkType,
  UUID,
} from '@builddocs/data-management'
import { AOSRType } from '@builddocs/filestore-api'
import { Typography, Stack } from '@mui/material'
import { Skeleton } from '@mui/material'

import { useGetAssignees } from './hooks/useGetAssignees'
import TableForSelect from './TableForSelect'
import { AOSRJsonType } from './Types/dataJSON'

interface AssigneesDialogAosrProps {
  workType: WorkType
  assigneeKey: string
  onSelect: (assignees: AssigneesProjectResponseType[]) => void
  dataJSON: AOSRJsonType
  act: AOSRType
}

export function AssigneesDialogAosr({
  workType,
  assigneeKey,
  onSelect,
  dataJSON,
  act,
}: AssigneesDialogAosrProps) {
  const assigneesFromFields = dataJSON[assigneeKey]?.assignees?.flatMap(
    assignee =>
      assignee.journalAssigneeId ? [assignee.journalAssigneeId] : [],
  )

  const overwrittenAssigneeIds = dataJSON[assigneeKey]?.overwrittenAssignees
    ? Object.keys(dataJSON[assigneeKey].overwrittenAssignees)
    : null

  const { data: assignees = [], isLoading } = useGetAssignees({
    workType,
    assigneeType: assigneeKey,
    actId: act.id,
  })

  const assigneesMap = useMemo(
    () =>
      assignees.reduce<Record<UUID, AssigneesProjectResponseType>>(
        (acc, assignee) =>
          assignee.journalAssigneeId
            ? {
                ...acc,
                [assignee.journalAssigneeId]: assignee,
              }
            : acc,
        {},
      ),
    [assignees],
  )

  const handleSelect = (selectedAssignees: UUID[] | UUID) => {
    const selectedAssigneeIds = Array.isArray(selectedAssignees)
      ? selectedAssignees
      : [selectedAssignees]
    const selectedAssigneesData = assignees.filter(assignee =>
      assignee.journalAssigneeId
        ? selectedAssigneeIds.includes(assignee.journalAssigneeId)
        : false,
    )

    onSelect?.(selectedAssigneesData)
  }

  if (isLoading) {
    return <Skeleton sx={{ height: 216 }} />
  }

  if (!assignees?.length) {
    return null
  }

  return (
    <Stack gap="12px">
      <Typography>Выберите представителя</Typography>
      <TableForSelect
        showAssigneeDocument
        showDefaultAssignees
        uniqueAssigneeByEmployment
        assigneeIdField="journalAssigneeId"
        items={assigneesMap}
        selected={overwrittenAssigneeIds ?? assigneesFromFields}
        tableType="assignees"
        onSelect={handleSelect}
      />
    </Stack>
  )
}
